import { ApiServiceV2 } from '@sunrise-upc/ajax-lib';
import { v4 as generateUID } from 'uuid';
import { APIResourceConstants } from '../api-constants';
import axios from 'axios';
import { MULTIPLEITEMACCESSORIES } from '../../utils/constants';
import { LineTableBasicPropConfig } from '../LineTableBasicPropConfig';
import { apiResConstants } from '../../components/LineCheckV3/APIResourceConstants';
import { getLocalStorageWithExpiry } from '../../utils/utils';

let source: any;
class multiItemAccessoryUpdateCartService {
  apiServiceInstance: ApiServiceV2;
  constructor() {
    this.apiServiceInstance = ApiServiceV2?.getApiServiceInstance();
  }
   //calling get cart
     getCart = (cartID: string) => {
    if (source) {
      source.cancel('Operation cancelled due to new request');
    }
    source = axios.CancelToken.source();

    const options = this.apiServiceInstance.getOption();
    /**
     * Code added for B2B cahnnel type change
     */
    let channel = apiResConstants.X_SUN_CHAL;
    // const cartAPIBasicAuth: string = LineTableBasicPropConfig?.getInstance()?.getAuthDetials(apiResConstants.THREE_SCALE_API_KEY);
    const cartBaseEndpoint: string = LineTableBasicPropConfig?.getInstance()?.getCartUrl();
    try {
      const channelB2B = getLocalStorageWithExpiry('isB2BCustomer');
      channel = channelB2B === 'SOHO' ? apiResConstants.X_SUN_B2B_CHAL : apiResConstants.X_SUN_CHAL;
    } catch (error: any) {
      // eslint-disable-next-line no-console
      console.log('erro while setting channle for b2b ==>', error);
    }

    options.headers = {
      ...options.headers,
      'x-correlation-id': generateUID(),
      'x-sunrise-channel': channel
    };
    //  commented for future purpose//  commented for future purpose
    // if (LineTableBasicPropConfig?.getInstance().isDevelopment()) {
    //   options.headers.Authorization = cartAPIBasicAuth;
    // } else {
    //   delete options.headers.Authorization;
    // }
    options.params = {};

    const URL = cartBaseEndpoint + apiResConstants.GET_CART.replace(':cartId', cartID);
    try {
      return this.apiServiceInstance
        .get(URL, options)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          if (!axios.isCancel(err)) {
            return {
              error: err
            };
          }
          return err;
        });
    } catch {
      throw Error('Promise failed');
    }
  };


  //for adding accessory to the cart
  getUpdateCartData = (cartId: any, payload: any, usecase?: string) => {
    if (source) {
      source?.cancel('Operation cancelled due to new request');
    }
    source = axios.CancelToken.source();
    const options = this.apiServiceInstance?.getOption();
    let accessoryUpdateSource: any;
    if (accessoryUpdateSource) {
      accessoryUpdateSource.cancel('Operation cancelled due to new request');
    }
    accessoryUpdateSource = axios.CancelToken.source();
    
    options.headers = {
      ...options?.headers,
      'x-correlation-id': generateUID(),
      'x-sunrise-channel': APIResourceConstants?.X_SUN_CHAL,
    };
    options.cancelToken = accessoryUpdateSource?.token;
    const cartBaseEndpoint: string = LineTableBasicPropConfig?.getInstance()?.getCartUrl();
    options.params = { usecase: usecase || MULTIPLEITEMACCESSORIES };
    options.cancelToken = source?.token;
    const URL = cartBaseEndpoint + APIResourceConstants?.UPDATE_CART + `${cartId}`;
    return this.apiServiceInstance
      ?.put(URL, payload)
      .then((res: any) => {
        return res?.data;
      })
      .catch((error: any) => {
        //returning error on 404
        if (error.response) {
          if (error.response.status === 404) {
            return [];
          }
          else {
            throw Error('Promise failed to add/remove recommended accessory Data due to Technical Error!');
          }
        } else {
          throw Error('Promise failed to add/remove recommended accessory Data due to Technical Error!');
        }
      });
  };
}

const multiItemAccessoryUpdateCartServices: multiItemAccessoryUpdateCartService = new multiItemAccessoryUpdateCartService();

export default multiItemAccessoryUpdateCartServices;